import React from "react"
export function InterchangeDestinations(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M5.82 10.249a.385.385 0 01.428.033l.057.055.038.055c.022.038.037.08.045.124l.006.067v2.255l6.915.013-.002 1.516-6.913-.013v2.262l-.006.07a.384.384 0 01-.57.263l-.054-.038-3.626-3.017-.049-.049a.384.384 0 01-.044-.426l.044-.065.05-.05 3.625-3.016.057-.04zm8.36-7.2l.056.04 3.626 3.017.049.049a.383.383 0 010 .491l-.05.05-3.625 3.016a.384.384 0 01-.624-.226l-.006-.069V7.155l-6.913.013-.002-1.516 6.915-.013V3.384c0-.068.018-.133.051-.191l.038-.055a.385.385 0 01.484-.088z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__interchange-destinations"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
